import React from 'react';
import { NavLink } from 'react-router-dom';

interface LogoProps {
  className?: string;
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({ className = '', onClick }) => {
  return (
    <NavLink 
      to="/" 
      onClick={onClick}
      className={`relative flex items-center group ${className}`}
      aria-label="EVOLVE XO Home"
    >
      <img 
        src="/assets/logo.png" 
        alt="EVOLVE XO" 
        className="h-10 md:h-16 lg:h-20 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
        loading="eager"
      />
    </NavLink>
  );
};

export default Logo;
